export default __webpack_public_path__ + "static/media/total_economia-atlas-new.430bf3b1.png";